import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d0b7cfc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "slider__slider",
  ref: "sliderElement"
}
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 0,
  class: "slider__exhibition_data"
}
const _hoisted_4 = { class: "exhibition_data__dates" }
const _hoisted_5 = { class: "exhibition_data__date" }
const _hoisted_6 = { class: "exhibition_data__date" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "exhibition_data__line" }, null, -1))
const _hoisted_8 = { class: "exhibition_data__title" }
const _hoisted_9 = {
  key: 0,
  class: "exhibition_data__subtitle"
}
const _hoisted_10 = {
  class: "slider__controls",
  ref: "sliderControls"
}
const _hoisted_11 = { class: "pagination__container" }
const _hoisted_12 = {
  key: 0,
  class: "pagination"
}
const _hoisted_13 = { class: "pagination__counter" }
const _hoisted_14 = { class: "pagination__controls" }
const _hoisted_15 = { class: "slider__caption_wrapper" }
const _hoisted_16 = ["data-caption"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _mergeProps({
      class: "slider__container",
      ref: "containerElement"
    }, _ctx.$attrs), [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, index) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent(slide.exhibition_data ? 'a' : 'div'), {
            class: _normalizeClass(["slide", { 'slide--active': index === _ctx.currentSlide }]),
            key: `slide-${index}`,
            href: slide.exhibition_data ? slide.exhibition_data.href : null,
            onClick: ($event: any) => (!slide.exhibition_data ? _ctx.gotoSlide(index) : null)
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                class: "slide__photo",
                src: slide.src,
                alt: slide.alt
              }, null, 8, _hoisted_2),
              _createElementVNode("div", {
                class: "slide__overlay",
                style: _normalizeStyle(`background-image: url('${slide.src}');`)
              }, null, 4),
              (slide.exhibition_data)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(slide.exhibition_data.date), 1),
                      _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("span", null, _toDisplayString(slide.exhibition_data.date2), 1)
                      ])
                    ]),
                    _createElementVNode("h4", _hoisted_8, [
                      (slide.exhibition_data.subtitle)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(slide.exhibition_data.subtitle), 1))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(slide.exhibition_data.title), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["class", "href", "onClick"]))
        }), 128))
      ], 512)
    ], 16),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        (_ctx.showSlideCount)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalSlides, (n) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "pagination__counter_item",
                    key: `pagination-item-${n}`,
                    style: _normalizeStyle(`transform: translateY(calc(${_ctx.currentSlide} * -1em)) `)
                  }, _toDisplayString(_ctx.formatTwoDecimal(n)), 5))
                }), 128))
              ]),
              _createTextVNode(" /" + _toDisplayString(_ctx.formatTwoDecimal(_ctx.totalSlides)), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_Icon, {
            type: "arrow-left",
            class: "pagination__arrow",
            onClick: _ctx.prevSlide
          }, null, 8, ["onClick"]),
          _createVNode(_component_Icon, {
            type: "arrow-right",
            class: "pagination__arrow",
            onClick: _ctx.nextSlide
          }, null, 8, ["onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "slider__caption_container",
            key: `slide-caption-${index}`
          }, [
            _createElementVNode("div", {
              class: "slider__caption",
              "data-caption": index
            }, _toDisplayString(slide.text), 9, _hoisted_16)
          ]))
        }), 128))
      ])
    ], 512)
  ], 64))
}